import React from 'react';
import { ChevronDown } from 'lucide-react';

const Hero = ({ t }) => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-section">
      <div className="hero-background">
        <img 
          src="https://images.unsplash.com/photo-1555952494-efd681c7e3f9?q=80&w=2070" 
          alt="Code background" 
          className="hero-image"
        />
        <div className="hero-overlay"></div>
      </div>
      
      <div className="hero-content">
        <div className="hero-subtitle">{t.hero.title}</div>
        <h1 className="hero-title">{t.hero.subtitle}</h1>
        <p className="hero-description">{t.hero.description}</p>
        
        <div className="hero-ctas">
          <button 
            className="btn-primary"
            onClick={() => scrollToSection('projects')}
          >
            {t.hero.cta1}
          </button>
          <button 
            className="btn-secondary"
            onClick={() => scrollToSection('contact')}
          >
            {t.hero.cta2}
          </button>
        </div>
      </div>

      <button 
        className="scroll-indicator"
        onClick={() => scrollToSection('about')}
      >
        <ChevronDown size={32} />
      </button>
    </section>
  );
};

export default Hero;